export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';
export const SET_ORGANIZATIONS_LOADING = 'SET_ORGANIZATIONS_LOADING';
export const SET_ORGANIZATIONS_ERROR = 'SET_ORGANIZATIONS_ERROR';
export const UPDATE_ORGANIZATIONS = 'UPDATE_ORGANIZATIONS';
